module.exports = "/images/side-publish-project.svg?7a3216073dfb1a41e51110ac8510f5e0";